"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconJanitorFilled = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    viewBox: "0 0 24 24",
    version: "1.1",
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M14.7617925,8.50746269 L14.7617925,2.16553596 L17.1226415,2.16553596 C17.572327,2.16553596 17.9658019,2.3202171 18.303066,2.62957938 C18.6403302,2.93894166 18.8262579,3.30845771 18.8608491,3.73812754 L18.8608491,4.51153324 L21.1698113,4.51153324 C21.4119497,4.51153324 21.6108491,4.59317051 21.7665094,4.75644505 C21.9221698,4.91971958 22,5.12166441 22,5.36227951 C22,5.56852103 21.9221698,5.75757576 21.7665094,5.92944369 C21.6108491,6.10131162 21.4119497,6.18724559 21.1698113,6.18724559 L18.8608491,6.18724559 L18.8608491,6.96065129 C18.8089623,7.39032112 18.6187107,7.75554048 18.2900943,8.05630936 C17.961478,8.35707825 17.572327,8.50746269 17.1226415,8.50746269 L14.7617925,8.50746269 Z M10.6108491,13.8697422 L4.66981132,13.8697422 L4.66981132,10.6729986 L4.1509434,10.6729986 C2.99213836,10.6386251 2.01061321,10.2089552 1.20636792,9.38398915 C0.402122642,8.55902307 0,7.57937585 0,6.44504749 L0,4.22795115 C0,3.076436 0.41509434,2.08389869 1.24528302,1.25033921 C2.0754717,0.416779738 3.07861635,0 4.25471698,0 L12.9716981,0 C13.4732704,0 13.8970126,0.171867933 14.2429245,0.515603799 C14.5888365,0.859339665 14.7617925,1.2718227 14.7617925,1.75305292 L14.7617925,8.91994573 C14.7617925,9.41836273 14.5888365,9.83514247 14.2429245,10.1702849 C13.8970126,10.5054274 13.4732704,10.6729986 12.9716981,10.6729986 L10.6108491,10.6729986 L10.6108491,13.8697422 Z M3.78773585,19 C3.4245283,19 3.11320755,18.8710991 2.85377358,18.6132972 C2.59433962,18.3554953 2.46462264,18.046133 2.46462264,17.6852103 L2.46462264,15.1845319 C2.46462264,14.8236092 2.59433962,14.5142469 2.85377358,14.256445 C3.11320755,13.9986431 3.4245283,13.8697422 3.78773585,13.8697422 L11.4669811,13.8697422 C11.8474843,13.8697422 12.1674528,13.9986431 12.4268868,14.256445 C12.6863208,14.5142469 12.8160377,14.8236092 12.8160377,15.1845319 L12.8160377,17.6852103 C12.8160377,18.046133 12.6863208,18.3554953 12.4268868,18.6132972 C12.1674528,18.8710991 11.8474843,19 11.4669811,19 L3.78773585,19 Z M11.129717,17.3500678 L4.1509434,17.3500678 L11.129717,17.3500678 Z",
        id: "path-1-904y729"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(-660.000000, -1389.000000)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(660.000000, 1389.000000)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(1.000000, 3.000000)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
              id: "mask-2-1254387",
              fill: "white",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                xlinkHref: "#path-1-904y729"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
              fill: "#000000",
              fillRule: "nonzero",
              xlinkHref: "#path-1-904y729"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              mask: "url(#mask-2-1254387)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                transform: "translate(-0.952381, -3.166667)",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  x: "0",
                  y: "0",
                  width: "24",
                  height: "24"
                })
              })
            })]
          })
        })
      })
    })]
  });
};
var _default = exports.default = (0, _withIcon.default)('IconJanitorFilled')(IconJanitorFilled);